import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Pivot from "./LeadAreaShop.Pivot";
import LeadAnalisiKPISet from "../leadAnalisi/LeadAnalisi.KPISet";

const LeadAreaShop = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPivot = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Leads')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <LeadAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPivot &&
                <Box className="report-itemgroup">
                    <Pivot dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

        </Box>
    )
}

export default LeadAreaShop;
